<!--
 * @Author: liushumin
 * @Date: 2022-09-14 18:05:05
 * @LastEditTime: 2022-09-29 14:53:55
 * @LastEditors: liushumin
-->
<template>
  <el-dialog
    title="录入物流信息"
    :visible.sync="dialogVisible_send"
    width="740px"
    :before-close="handleClose"
    class="szDialog sgDialog"
  >
    <el-form
      :model="dynamicValAddForm"
      :rules="sendRules"
      ref="dynamicValAddForm"
      class="demo-dynamic"
    >
      <el-form-item prop="saleOrderTime" label="发货时间">
        <el-date-picker
          v-model="dynamicValAddForm.saleOrderTime"
          type="date"
          placeholder="发货时间"
          value-format="yyyy-MM-dd"
          style="width: 320px"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item prop="contacts" label="承运对象">
        <el-input
          type="text"
          placeholder="请输入承运人姓名"
          style="width: 70%"
          v-model="dynamicValAddForm.contacts"
          maxlength="50"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="telPhone" label="承运人联系方式">
        <el-input
          type="text"
          placeholder="请输入承运人联系方式"
          style="width: 70%"
          maxlength="11"
          oninput="value=value.replace(/[^0-9]/g,'')"
          v-model="dynamicValAddForm.telPhone"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="remark" label=" 备注">
        <el-input
          type="textarea"
          :rows="3"
          style="width: 70%"
          placeholder="请输入备注"
          v-model="dynamicValAddForm.remark"
          maxlength="50"
        >
        </el-input>
        <p style="padding-left: 140px">
          温馨提示：如使用快递发货,请在备注处输入快递单号
        </p>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button
        type="primary"
        :disabled="stepLoading"
        @click="submitForm('dynamicValAddForm')"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: ["openStatus", "orderId"],
  data() {
    return {
      stepLoading: false,
      dialogVisible_send: false,
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      dynamicValAddForm: {
        contacts: "",
        telPhone: "",
        remark: "",
        orderId: "",
        saleOrderTime: "",
      },
      sendRules: {
        saleOrderTime: [
          {
            required: true,
            message: "请发货时间",
            trigger: "change",
          },
        ],
        contacts: [
          { required: true, message: "请输入承运人姓名", trigger: "blur" },
        ],
        telPhone: [
          { required: true, message: "请输入承运人联系方式", trigger: "blur" },
        ],
        remark: [{ required: true, message: "请输入备注", trigger: "blur" }],
      },
      checked1: false,
    };
  },
  watch: {
    openStatus(val1, val2) {
      this.dialogVisible_send = this.openStatus;
    },
  },
  mounted() {
    if(sessionStorage.getItem("infoShObj") != null) {
      this.dynamicValAddForm = JSON.parse(sessionStorage.getItem("infoShObj"))[0];
    }
    this.dynamicValAddForm.orderId = this.orderId;
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sendOrderList();
        } else {
          return false;
        }
      });
    },
    
    // 修改收货人信息接口
    sendOrderList() {
      this.stepLoading = true;
      this.$http.szOrder.confirmDelivery(this.dynamicValAddForm).then((res) => {
        this.stepLoading = false;
        if (res.status == 1) {
          this.dialogVisible_send = false;
          this.$emit("closeSendStatus", true);
          this.$message({
            message: "发货成功",
            type: "success",
          });
          setTimeout(() => {
            this.stepLoading = false;
          }, 1000);
        }
      });
    },
    handleClose() {
      this.dialogVisible_send = false;
      this.$emit("closeStatus", true);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../../../styles/order-global.scss';
</style>
